// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.0
//   protoc               v6.30.2
// source: services/security/user_profile.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { grpc } from "@improbable-eng/grpc-web";
import { BrowserHeaders } from "browser-headers";
import { EmptyRequest, EmptyResponse } from "../../common/messages/messages";

export const protobufPackage = "services.security";

export interface DigitalIdFile {
  email: string;
  fileId: string;
}

export interface UserProfile {
  portalUserName: string;
  profileImageId?: string | undefined;
  email?: string | undefined;
  fullName?: string | undefined;
  digitalIdFiles: DigitalIdFile[];
  confirm?: boolean | undefined;
}

export interface GetAllProfilesResponse {
  profiles: UserProfile[];
}

export interface GetUserProfileResponse {
  profile: UserProfile | undefined;
  version: number;
}

export interface UpdateUserProfileRequest {
  profile: UserProfile | undefined;
  version: number;
}

function createBaseDigitalIdFile(): DigitalIdFile {
  return { email: "", fileId: "" };
}

export const DigitalIdFile: MessageFns<DigitalIdFile> = {
  encode(message: DigitalIdFile, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.email !== "") {
      writer.uint32(10).string(message.email);
    }
    if (message.fileId !== "") {
      writer.uint32(18).string(message.fileId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DigitalIdFile {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDigitalIdFile();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fileId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DigitalIdFile {
    return {
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      fileId: isSet(object.fileId)
        ? globalThis.String(object.fileId)
        : isSet(object.file_id)
        ? globalThis.String(object.file_id)
        : "",
    };
  },

  toJSON(message: DigitalIdFile): unknown {
    const obj: any = {};
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.fileId !== "") {
      obj.fileId = message.fileId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DigitalIdFile>, I>>(base?: I): DigitalIdFile {
    return DigitalIdFile.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DigitalIdFile>, I>>(object: I): DigitalIdFile {
    const message = createBaseDigitalIdFile();
    message.email = object.email ?? "";
    message.fileId = object.fileId ?? "";
    return message;
  },
};

function createBaseUserProfile(): UserProfile {
  return {
    portalUserName: "",
    profileImageId: undefined,
    email: undefined,
    fullName: undefined,
    digitalIdFiles: [],
    confirm: undefined,
  };
}

export const UserProfile: MessageFns<UserProfile> = {
  encode(message: UserProfile, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.portalUserName !== "") {
      writer.uint32(10).string(message.portalUserName);
    }
    if (message.profileImageId !== undefined) {
      writer.uint32(18).string(message.profileImageId);
    }
    if (message.email !== undefined) {
      writer.uint32(26).string(message.email);
    }
    if (message.fullName !== undefined) {
      writer.uint32(34).string(message.fullName);
    }
    for (const v of message.digitalIdFiles) {
      DigitalIdFile.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.confirm !== undefined) {
      writer.uint32(48).bool(message.confirm);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserProfile {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserProfile();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.portalUserName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.profileImageId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.email = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fullName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.digitalIdFiles.push(DigitalIdFile.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.confirm = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserProfile {
    return {
      portalUserName: isSet(object.portalUserName)
        ? globalThis.String(object.portalUserName)
        : isSet(object.portal_user_name)
        ? globalThis.String(object.portal_user_name)
        : "",
      profileImageId: isSet(object.profileImageId)
        ? globalThis.String(object.profileImageId)
        : isSet(object.profile_image_id)
        ? globalThis.String(object.profile_image_id)
        : undefined,
      email: isSet(object.email) ? globalThis.String(object.email) : undefined,
      fullName: isSet(object.fullName)
        ? globalThis.String(object.fullName)
        : isSet(object.full_name)
        ? globalThis.String(object.full_name)
        : undefined,
      digitalIdFiles: globalThis.Array.isArray(object?.digitalIdFiles)
        ? object.digitalIdFiles.map((e: any) => DigitalIdFile.fromJSON(e))
        : globalThis.Array.isArray(object?.digital_id_files)
        ? object.digital_id_files.map((e: any) => DigitalIdFile.fromJSON(e))
        : [],
      confirm: isSet(object.confirm) ? globalThis.Boolean(object.confirm) : undefined,
    };
  },

  toJSON(message: UserProfile): unknown {
    const obj: any = {};
    if (message.portalUserName !== "") {
      obj.portalUserName = message.portalUserName;
    }
    if (message.profileImageId !== undefined) {
      obj.profileImageId = message.profileImageId;
    }
    if (message.email !== undefined) {
      obj.email = message.email;
    }
    if (message.fullName !== undefined) {
      obj.fullName = message.fullName;
    }
    if (message.digitalIdFiles?.length) {
      obj.digitalIdFiles = message.digitalIdFiles.map((e) => DigitalIdFile.toJSON(e));
    }
    if (message.confirm !== undefined) {
      obj.confirm = message.confirm;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserProfile>, I>>(base?: I): UserProfile {
    return UserProfile.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserProfile>, I>>(object: I): UserProfile {
    const message = createBaseUserProfile();
    message.portalUserName = object.portalUserName ?? "";
    message.profileImageId = object.profileImageId ?? undefined;
    message.email = object.email ?? undefined;
    message.fullName = object.fullName ?? undefined;
    message.digitalIdFiles = object.digitalIdFiles?.map((e) => DigitalIdFile.fromPartial(e)) || [];
    message.confirm = object.confirm ?? undefined;
    return message;
  },
};

function createBaseGetAllProfilesResponse(): GetAllProfilesResponse {
  return { profiles: [] };
}

export const GetAllProfilesResponse: MessageFns<GetAllProfilesResponse> = {
  encode(message: GetAllProfilesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.profiles) {
      UserProfile.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAllProfilesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllProfilesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.profiles.push(UserProfile.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAllProfilesResponse {
    return {
      profiles: globalThis.Array.isArray(object?.profiles)
        ? object.profiles.map((e: any) => UserProfile.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetAllProfilesResponse): unknown {
    const obj: any = {};
    if (message.profiles?.length) {
      obj.profiles = message.profiles.map((e) => UserProfile.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAllProfilesResponse>, I>>(base?: I): GetAllProfilesResponse {
    return GetAllProfilesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAllProfilesResponse>, I>>(object: I): GetAllProfilesResponse {
    const message = createBaseGetAllProfilesResponse();
    message.profiles = object.profiles?.map((e) => UserProfile.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetUserProfileResponse(): GetUserProfileResponse {
  return { profile: undefined, version: 0 };
}

export const GetUserProfileResponse: MessageFns<GetUserProfileResponse> = {
  encode(message: GetUserProfileResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.profile !== undefined) {
      UserProfile.encode(message.profile, writer.uint32(10).fork()).join();
    }
    if (message.version !== 0) {
      writer.uint32(16).int64(message.version);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetUserProfileResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetUserProfileResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.profile = UserProfile.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.version = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetUserProfileResponse {
    return {
      profile: isSet(object.profile) ? UserProfile.fromJSON(object.profile) : undefined,
      version: isSet(object.version) ? globalThis.Number(object.version) : 0,
    };
  },

  toJSON(message: GetUserProfileResponse): unknown {
    const obj: any = {};
    if (message.profile !== undefined) {
      obj.profile = UserProfile.toJSON(message.profile);
    }
    if (message.version !== 0) {
      obj.version = Math.round(message.version);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetUserProfileResponse>, I>>(base?: I): GetUserProfileResponse {
    return GetUserProfileResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetUserProfileResponse>, I>>(object: I): GetUserProfileResponse {
    const message = createBaseGetUserProfileResponse();
    message.profile = (object.profile !== undefined && object.profile !== null)
      ? UserProfile.fromPartial(object.profile)
      : undefined;
    message.version = object.version ?? 0;
    return message;
  },
};

function createBaseUpdateUserProfileRequest(): UpdateUserProfileRequest {
  return { profile: undefined, version: 0 };
}

export const UpdateUserProfileRequest: MessageFns<UpdateUserProfileRequest> = {
  encode(message: UpdateUserProfileRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.profile !== undefined) {
      UserProfile.encode(message.profile, writer.uint32(10).fork()).join();
    }
    if (message.version !== 0) {
      writer.uint32(16).int64(message.version);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateUserProfileRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateUserProfileRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.profile = UserProfile.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.version = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateUserProfileRequest {
    return {
      profile: isSet(object.profile) ? UserProfile.fromJSON(object.profile) : undefined,
      version: isSet(object.version) ? globalThis.Number(object.version) : 0,
    };
  },

  toJSON(message: UpdateUserProfileRequest): unknown {
    const obj: any = {};
    if (message.profile !== undefined) {
      obj.profile = UserProfile.toJSON(message.profile);
    }
    if (message.version !== 0) {
      obj.version = Math.round(message.version);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateUserProfileRequest>, I>>(base?: I): UpdateUserProfileRequest {
    return UpdateUserProfileRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateUserProfileRequest>, I>>(object: I): UpdateUserProfileRequest {
    const message = createBaseUpdateUserProfileRequest();
    message.profile = (object.profile !== undefined && object.profile !== null)
      ? UserProfile.fromPartial(object.profile)
      : undefined;
    message.version = object.version ?? 0;
    return message;
  },
};

export interface UserProfileService {
  getAllProfiles(request: DeepPartial<EmptyRequest>, metadata?: grpc.Metadata): Promise<GetAllProfilesResponse>;
  getByToken(request: DeepPartial<EmptyRequest>, metadata?: grpc.Metadata): Promise<GetUserProfileResponse>;
  updateUserProfile(request: DeepPartial<UpdateUserProfileRequest>, metadata?: grpc.Metadata): Promise<EmptyResponse>;
  addUserProfile(request: DeepPartial<UserProfile>, metadata?: grpc.Metadata): Promise<EmptyResponse>;
}

export class UserProfileServiceClientImpl implements UserProfileService {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.getAllProfiles = this.getAllProfiles.bind(this);
    this.getByToken = this.getByToken.bind(this);
    this.updateUserProfile = this.updateUserProfile.bind(this);
    this.addUserProfile = this.addUserProfile.bind(this);
  }

  getAllProfiles(request: DeepPartial<EmptyRequest>, metadata?: grpc.Metadata): Promise<GetAllProfilesResponse> {
    return this.rpc.unary(UserProfileServiceGetAllProfilesDesc, EmptyRequest.fromPartial(request), metadata);
  }

  getByToken(request: DeepPartial<EmptyRequest>, metadata?: grpc.Metadata): Promise<GetUserProfileResponse> {
    return this.rpc.unary(UserProfileServiceGetByTokenDesc, EmptyRequest.fromPartial(request), metadata);
  }

  updateUserProfile(request: DeepPartial<UpdateUserProfileRequest>, metadata?: grpc.Metadata): Promise<EmptyResponse> {
    return this.rpc.unary(
      UserProfileServiceUpdateUserProfileDesc,
      UpdateUserProfileRequest.fromPartial(request),
      metadata,
    );
  }

  addUserProfile(request: DeepPartial<UserProfile>, metadata?: grpc.Metadata): Promise<EmptyResponse> {
    return this.rpc.unary(UserProfileServiceAddUserProfileDesc, UserProfile.fromPartial(request), metadata);
  }
}

export const UserProfileServiceDesc = { serviceName: "services.security.UserProfileService" };

export const UserProfileServiceGetAllProfilesDesc: UnaryMethodDefinitionish = {
  methodName: "GetAllProfiles",
  service: UserProfileServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return EmptyRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetAllProfilesResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const UserProfileServiceGetByTokenDesc: UnaryMethodDefinitionish = {
  methodName: "GetByToken",
  service: UserProfileServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return EmptyRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = GetUserProfileResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const UserProfileServiceUpdateUserProfileDesc: UnaryMethodDefinitionish = {
  methodName: "UpdateUserProfile",
  service: UserProfileServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return UpdateUserProfileRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = EmptyResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

export const UserProfileServiceAddUserProfileDesc: UnaryMethodDefinitionish = {
  methodName: "AddUserProfile",
  service: UserProfileServiceDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return UserProfile.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = EmptyResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

interface UnaryMethodDefinitionishR extends grpc.UnaryMethodDefinition<any, any> {
  requestStream: any;
  responseStream: any;
}

type UnaryMethodDefinitionish = UnaryMethodDefinitionishR;

interface Rpc {
  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any>;
}

export class GrpcWebImpl {
  private host: string;
  private options: {
    transport?: grpc.TransportFactory;

    debug?: boolean;
    metadata?: grpc.Metadata;
    upStreamRetryCodes?: number[];
  };

  constructor(
    host: string,
    options: {
      transport?: grpc.TransportFactory;

      debug?: boolean;
      metadata?: grpc.Metadata;
      upStreamRetryCodes?: number[];
    },
  ) {
    this.host = host;
    this.options = options;
  }

  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any> {
    const request = { ..._request, ...methodDesc.requestType };
    const maybeCombinedMetadata = metadata && this.options.metadata
      ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
      : metadata ?? this.options.metadata;
    return new Promise((resolve, reject) => {
      grpc.unary(methodDesc, {
        request,
        host: this.host,
        metadata: maybeCombinedMetadata ?? {},
        ...(this.options.transport !== undefined ? { transport: this.options.transport } : {}),
        debug: this.options.debug ?? false,
        onEnd: function (response) {
          if (response.status === grpc.Code.OK) {
            resolve(response.message!.toObject());
          } else {
            const err = new GrpcWebError(response.statusMessage, response.status, response.trailers);
            reject(err);
          }
        },
      });
    });
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export class GrpcWebError extends globalThis.Error {
  constructor(message: string, public code: grpc.Code, public metadata: grpc.Metadata) {
    super(message);
  }
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
